import React, { Component } from 'react';
import { Select, Input, Divider, Row, Checkbox, Button, message, Tag, InputNumber } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../../lib/util';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import ScheduleChanger from '../../../components/schedule_changer';


class CronAddEdit extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      form_data: this.props.edit_data || {},
      edit_id: this.props.edit_id,
      crons: {},
      cronSchema: []
    }



    this.list_crons = RESTExecutor.list().config({
      label: 'cron_jobs',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
      let crons = {};
      success.result.rows.map((item) => {
        crons[item.id] = item
      });
      this.setState({
        crons: crons
      });

      if (this.props.edit_id) {
        this.setState({
          cronSchema: schema_to_field(crons[this.props.edit_data.plugin_id].validation_config || {})
        })
      }

    })
      .connect(props.domains.plugins);


    this.post_fetcher_config = RESTExecutor.post().config({
      label: 'list'
    }).callbacks((success) => {
      message.success("Config Added Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.cron);

    this.patch_fetcher_config = RESTExecutor.patch().config({
      label: 'detail',
    }).callbacks((success) => {
      message.success("Config Modified Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()


    }, (error) => {
      showErrorInNotification(error)
        }).connect(props.domains.cron);


  }
  

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  handlePostPatch = () => {
    if (this.state.edit_id) {
      this.patch_fetcher_config.forId(this.state.edit_id).execute(this.state.form_data)
    } else {
      this.post_fetcher_config.execute(this.state.form_data);
    }
  }

  scheduleUpdater = ({ key, value }) => {
    let form_data = this.state.form_data;
    if (!form_data.schedule) {
      form_data.schedule = {}
    }
    form_data.schedule[key] = value;
    this.setState({
      form_data: form_data
    })
  }

  render() {
     const { crons, form_data, edit_id, source_id } = this.state;
    let schedule = form_data.schedule || {};

    // console.log("days list",day_list)
    return (
      <div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit-content',
              textAlign: 'right',
              justifyContent: 'center'
            }}
            >
              <span>
                Cron Name: &nbsp; <Input
                  placeholder={"Cron  Name"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'name', value: e.target.value })
                  }}
                  value={form_data.name}
                  style={{
                    width: 300
                  }} >
                </Input>
              </span>
              {/* <br></br>
              <span>
                Cron Description: &nbsp; <Input.TextArea
                  placeholder={"Cron  Description"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'description', value: e.target.value })
                  }}
                  value={form_data.description}
                  style={{
                    width: 300
                  }} >
                </Input.TextArea>
              </span> */}
              <br></br>
              <span>Cron: <Select style={{ width: 300 }}
                placeholder="Cron"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.plugin_id}
                onChange={(value) => {
                  this.stateUpdater({
                    stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                      this.stateUpdater({ stateKey: 'form_data', valueKey: 'plugin_params', value: {} })
                    }
                  });
                  this.setState({
                    cronSchema: schema_to_field(crons[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(crons).map((key, index) => {
                    let item = crons[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>
            </div>
          </Row>
          <br></br>
          {this.state.cronSchema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data.plugin_params || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.stateUpdater({
                    stateKey: 'form_data',
                    valueKey: 'plugin_params',
                    value: data,
                  });
                }}
                fields={this.state.cronSchema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}

          <React.Fragment>
            <Divider style={{
            marginTop: 8,
            marginBottom: 8
          }} />
          <Title style={{ margin: 0 }} level={4} type='secondary'>Schedule</Title>
          <ScheduleChanger 
          schedule={schedule}
          onChange={(schedule)=>{
            console.log("Schedule is",schedule)
            this.stateUpdater({ stateKey: 'form_data', valueKey: 'schedule', value:schedule })

          }}
          />
          </React.Fragment>


          <br></br>
          <br></br>
          <Row type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button type='primary' onClick={() => {
                this.handlePostPatch()
              }}>Submit</Button>
            </div>
          </Row>


        </div>

      </div>
    );
  }

  componentDidMount() {
    this.list_crons.execute()
  }


  componentDidUpdate = (prevProps) => {
    if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
      this.list_crons.execute()
      this.setState({
        edit_id: this.props.edit_id,
        form_data: this.props.edit_data
      })
    };

  }
}

export default withDomains(CronAddEdit,'cron','plugins');
